import { Box, Button, Flex, Text } from "@chakra-ui/react";
import { Modal } from "antd";
import React from "react";
import ConfirmationModal from "../../Components/Modals/ConfirmationModal";
import CreateMeetModal from "../../Components/Modals/CreateMeetModal";
import FilterModal from "../../Components/Modals/FilterModal";
import NotesModal from "../../Components/Modals/NotesModal";
import RelevanceModal from "../../Components/Modals/RelevanceModal";
import SortModal from "../../Components/Modals/SortModal";

// Claude: extracted from BuyersList.tsx 23-03-2026
interface Props {
  navigate: (path: string) => void;
  addNewBuyer: boolean; handleCloseBuyerAddModal: () => void; addBuyer: () => void;
  meetConfirm: boolean; handleCloseMeetConfirmModal: () => void; currentMeet: string;
  meetModal: boolean; handleCloseMeetModal: () => void; meetResponder: any; sellerData: any; details: { company: string; event: string };
  verifyGateOpen: boolean; setVerifyGateOpen: (v: boolean) => void;
  notesModal: boolean; handleCloseNotesModal: () => void; notesData: any;
  sortModal: boolean; handleCloseSortModal: () => void; orderSort: string; setOrderSort: (v: string) => void;
  filterModal: boolean; handleCloseFilterModal: () => void; relevanceSort: string; setRelevanceSort: (v: string) => void;
  releModal: boolean; handleCloseRelevanceModal: () => void; relevanceData: any; reloadData: () => void;
}

const BuyersListModals = ({
  navigate,
  addNewBuyer, handleCloseBuyerAddModal, addBuyer,
  meetConfirm, handleCloseMeetConfirmModal, currentMeet,
  meetModal, handleCloseMeetModal, meetResponder, sellerData, details,
  verifyGateOpen, setVerifyGateOpen,
  notesModal, handleCloseNotesModal, notesData,
  sortModal, handleCloseSortModal, orderSort, setOrderSort,
  filterModal, handleCloseFilterModal, relevanceSort, setRelevanceSort,
  releModal, handleCloseRelevanceModal, relevanceData, reloadData,
}: Props) => (
  <>
    <Modal closeIcon={null} footer={null} title={null} open={addNewBuyer} onOk={handleCloseBuyerAddModal} onCancel={handleCloseBuyerAddModal}>
      <ConfirmationModal
        handleCloseModal={handleCloseBuyerAddModal}
        handleSubmit={addBuyer}
        title={"Matching buyer found !"}
        message={"Add to your list ?"}
        confirmBtnText={"Yes, Add"}
        rejectButtonText={"No"}
      />
    </Modal>
    <Modal closeIcon={null} footer={null} title={null} open={meetConfirm} onOk={handleCloseMeetConfirmModal} onCancel={handleCloseMeetConfirmModal}>
      <ConfirmationModal
        handleCloseModal={handleCloseMeetConfirmModal}
        handleSubmit={() => navigate("/seller/calendar?id=" + currentMeet)}
        title={"Open meeting already exists"}
        message={"Please view & edit the same.  View details now ?"}
        confirmBtnText={"Yes, View"}
        rejectButtonText={"No"}
      />
    </Modal>
    <Modal closeIcon={null} footer={null} title={null} open={meetModal} onOk={handleCloseMeetModal} onCancel={handleCloseMeetModal}>
      <CreateMeetModal
        meetRequesterPhone={sellerData.personPhoneNumber}
        responderId={meetResponder?.userId}
        eventId={details.event}
        company={meetResponder?.buyerPersonName}
        buyerCompanyName={meetResponder?.buyerCompanyName}
        designation={meetResponder?.buyerDesignation}
        context="Inquiry"
        handleCloseModal={handleCloseMeetModal}
      />
    </Modal>
    <Modal open={verifyGateOpen} onCancel={() => setVerifyGateOpen(false)} footer={null} title={null} closeIcon={null} centered>
      <Box py={2}>
        <Text fontSize="md" fontWeight={600} mb={2} color="#0E122F">Profile Verification Required</Text>
        <Text fontSize="sm" color="gray.600" mb={5}>Please complete your profile verification to use this feature.</Text>
        <Flex gap={2} justifyContent="flex-end">
          <Button size="sm" variant="ghost" onClick={() => setVerifyGateOpen(false)}>Cancel</Button>
          <Button size="sm" bg="#0E122F" color="white" borderRadius="8px" _hover={{ bg: "#2E3560" }}
            onClick={() => { setVerifyGateOpen(false); navigate("/seller/profile"); }}>
            Go to Profile
          </Button>
        </Flex>
      </Box>
    </Modal>
    <Modal closeIcon={null} footer={null} title={null} open={notesModal} onOk={handleCloseNotesModal} onCancel={handleCloseNotesModal}>
      <NotesModal eventId={notesData.eventId} forUser={notesData.forUser} companyName={notesData.companyName} handleCloseModal={handleCloseNotesModal} />
    </Modal>
    <Modal closeIcon={null} footer={null} title={null} open={sortModal} onOk={handleCloseSortModal} onCancel={handleCloseSortModal}>
      <SortModal handleCloseModal={handleCloseSortModal} orderSort={orderSort} setOrderSort={setOrderSort} />
    </Modal>
    <Modal closeIcon={null} footer={null} title={null} open={filterModal} onOk={handleCloseFilterModal} onCancel={handleCloseFilterModal}>
      <FilterModal handleCloseModal={handleCloseFilterModal} relevanceSort={relevanceSort} setRelevanceSort={setRelevanceSort} />
    </Modal>
    <Modal closeIcon={null} footer={null} title={null} open={releModal} onOk={handleCloseRelevanceModal} onCancel={handleCloseRelevanceModal}>
      <RelevanceModal data={relevanceData} relaodData={reloadData} handleCloseModal={handleCloseRelevanceModal} />
    </Modal>
  </>
);

export default BuyersListModals;
